import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

var firebaseConfig = {
  apiKey: "AIzaSyAhqduLg2xbAcL-uftbnqFMhu7SucGWiBo",
  authDomain: "youtube-moments.firebaseapp.com",
  databaseURL: "https://youtube-moments.firebaseio.com",
  projectId: "youtube-moments",
  storageBucket: "youtube-moments.appspot.com",
  messagingSenderId: "520300588500",
  appId: "1:520300588500:web:6c85e47eb8f23197edba41",
};
firebase.initializeApp(firebaseConfig);

const database = firebase.database();

export function createVideo(firebaseId, ytVideoId, start, end, user) {
  const videoRef = database.ref(`videos/${firebaseId}`);
  videoRef.child("infos").set({
    id: ytVideoId,
    start,
    end,
    created_at: Date.now(),
    author: user.uid,
  });
  return videoRef.child("views/count").set(0);
}

export default firebase;



/** WEBPACK FOOTER **
 ** ./src/scripts/sdks/firebase.js
 **/